// components/ScheduleRow.jsx
import React from 'react';
import { RadioGroup } from './RadioGroup';
import { HoursInput } from './HoursInput';

export const ScheduleRow = ({ 
  dayKey,
  title,
  schedule,
  onActiveChange,
  onTimeChange
}) => {
  return (
    <tr>
      <td className="align-middle">{title}</td>
      <td className="align-middle">
        <RadioGroup
          name={`day_${dayKey}`}
          checked={schedule.active}
          onChange={(value) => onActiveChange(dayKey, value)}
        />
      </td>
      <td className="align-middle">
        <HoursInput
          disabled={!schedule.active}
          from={schedule.time.from}
          to={schedule.time.to}
          onFromChange={(value) => onTimeChange(dayKey, 'from', value)}
          onToChange={(value) => onTimeChange(dayKey, 'to', value)}
        />
      </td>
    </tr>
  );
};